
/* eslint-disable @rushstack/typedef-var */
// This source was automatically generated, using the contents of:
//
//     src/scss/_global.scss
//
// Note that each "'name': value" line below is preceded by a comment so that when referencing
// that named variable, VS Code will display the contents of the comment when the cursor is
// displayed over the variable reference.  That way, the value of the CSS variable can easily
// be seen, along with the comment that appeared with the variable in the CSS file (if any).

export const cssVar = {
	// NOTE:  A TypeScripe file, "css-var.ts", is auto-generated based on the contents of this file using
	// a custom code-generator we built.  If you modify this "_global.scss" file, please ask a
	// Desktop develop (e.g. Rich W.) to re-run that code-generator to update the corresponding
	// TypeScript.
	// The command line to update the content of "css-var.ts" file is:
	// npm run cssGen

	// Global Variables
	// Colors - Note our primary, accent and warn colors are located in touchplan-theme.scss these are our main colors and material adds them in for us.
	// Repeating a couple of examples here to match betwen Material and Legacy portions of the app
	// primary = touchplan dark blue, accent = orange, warn = red
	// Usage examples are not all-inclusive

	// Material (Modern) Color Palette
	'touchplanBlueDark': '#00a0cc',
	'touchplanBlueDark_number': 0x00a0cc,
	'touchplanBlueDarker': '#133c47',
	'touchplanBlueDarker_number': 0x133c47,
	'touchplanBlue900': '#0073ad',
	'touchplanBlue900_number': 0x0073ad,
	'touchplanBlue': '#4dbddb',
	'touchplanBlue_number': 0x4dbddb,
	'touchplanBlueLight': '#80d0e6',
	'touchplanBlueLight_number': 0x80d0e6,
	'touchplanBlueLighter': '#e0f4f9',
	'touchplanBlueLighter_number': 0xe0f4f9,
	'touchplanBlueGrey': '#e7ebec',
	'touchplanBlueGrey_number': 0xe7ebec,
	'touchplanAccent': '#ce5635',
	'touchplanAccent_number': 0xce5635,
	'white': '#ffffff',
	'white_number': 0xffffff,
	'black': '#000000',
	'black_number': 0x000000,
	'purple': '#5635ce',
	'purple_number': 0x5635ce,
	// grey #'s are % opacity of black
	'grey2': '#fafafa',
	'grey2_number': 0xfafafa,
	'grey12': '#e0e0e0',
	'grey12_number': 0xe0e0e0,
	'grey38': '#9e9e9e',
	'grey38_number': 0x9e9e9e,
	'grey54': '#757575',
	'grey54_number': 0x757575,
	'grey60': '#666666',
	'grey60_number': 0x666666,
	'red': '#be1c1d',
	'red_number': 0xbe1c1d,
	'yellow': '#eab76a',
	'yellow_number': 0xeab76a,
	'green': '#2bab85',
	'green_number': 0x2bab85,
	'lightGreen': '#95c98c',
	'lightGreen_number': 0x95c98c,
	'paleGreen': '#b6f2b6',
	'paleGreen_number': 0xb6f2b6,
	'ghostlineBlue': '#4587ff4d',
	'timelineTicketGrey': '#444444',
	'timelineTicketGrey_number': 0x444444,
	'timelineHeight': '38px',
	'timelineHeight_px': 38,
	'promisePeriodLastColor': '#45b29dcc',
	'promisePeriodLastAlpha': 0.8,
	'promisePeriodNextColor': '#4093bf',
	'promisePeriodNextColor_number': 0x4093bf,
	'promisePeriodNextAlpha': 0.8,
	'promisePeriodMinimizedAlpha': 0.2,
	'promisePeriodMinimizedHeight': '4px',
	'promisePeriodMinimizedHeight_px': 4,
	'promisePeriodTextSize': '13px',
	'promisePeriodTextSize_px': 13,
	'promisePeriodButtonWidth': '165px',
	'promisePeriodButtonWidth_px': 165,

	// *** do not use on new work *** Legacy Color Palette
	'lighterWhite': '#f1f1f1',
	'lighterWhite_number': 0xf1f1f1,
	'lightGrey': '#e0e0e0',
	'lightGrey_number': 0xe0e0e0,
	'grey': '#888888',
	'grey_number': 0x888888,
	'darkGrey': '#666666',
	'darkGrey_number': 0x666666,
	'darkerGrey': '#484848',
	'darkerGrey_number': 0x484848,
	'almostBlack': '#333333',
	'almostBlack_number': 0x333333,
	'touchplanRed': '#be1c1d',
	'touchplanRed_number': 0xbe1c1d,
	'touchplanRedDarker': '#cd3b3b',
	'touchplanRedDarker_number': 0xcd3b3b,
	'touchplanRedDark': '#ea3939',
	'touchplanRedDark_number': 0xea3939,
	'touchplanRedLight': '#fbf0f0',
	'touchplanRedLight_number': 0xfbf0f0,
	'yellowLight': '#f7ef5c',
	'yellowLight_number': 0xf7ef5c,
	'yellowDark': '#b58104',
	'yellowDark_number': 0xb58104,
	'greenDark': '#278213',
	'greenDark_number': 0x278213,
	'touchplanLime': '#00ff00',
	'touchplanLime_number': 0x00ff00,
	'planAheadLegacy': '#b8dbb4',
	'planAheadLegacy_number': 0xb8dbb4,
	'planBehindLegacy': '#ffcccc',
	'planBehindLegacy_number': 0xffcccc,

	// Material (Modern) Size and Appearance Variables
	// Typography
	'fontFamily': '\'Roboto\', \'Helvetica Neue\', Arial, sans-serif',
	// h1 - Material provides this
	'h2FontSize': '20px',
	'h2FontSize_px': 20,
	'h3FontSize': '16px',
	'h3FontSize_px': 16,
	'h4FontSize': '14px',
	'h4FontSize_px': 14,
	'h5FontSize': '13px',
	'h5FontSize_px': 13,
	'h6FontSize': '12px',
	'h6FontSize_px': 12,
	'listIconFontSize': '24px',
	'listIconFontSize_px': 24,
	'largeCheckboxSize': '32px',
	'largeCheckboxSize_px': 32,
	'fontawesomePro': '\'Font Awesome 5 Pro\'',

	// Font Weights
	'thin': 300,
	'normal': 400,
	'medium': 500,
	'bold': 700,

	// Generic spacing: use this for paddings, margins, whatever that needs space added to it
	// Material increases padding by an increment of 4px
	'space4': '4px',
	'space4_px': 4,
	'space8': '8px',
	'space8_px': 8,
	'space12': '12px',
	'space12_px': 12,
	'space16': '16px',
	'space16_px': 16,
	'space20': '20px',
	'space20_px': 20,
	'space24': '24px',
	'space24_px': 24,
	'space40': '40px',
	'space40_px': 40,

	// Dialog Box Sizes
	// widths
	'dialogWidthSm': '336px',
	'dialogWidthSm_px': 336,
	'dialogWidthMd': '500px',
	'dialogWidthMd_px': 500,
	'dialogWidthLg': '760px',
	'dialogWidthLg_px': 760,
	'dialogWidthXl': '1000px',
	'dialogWidthXl_px': 1000,

	// heights - DEFAULT SHOULD BE TO NOT SPECIFY
	'dialogHeightSm': '540px',
	'dialogHeightSm_px': 540,
	'dialogHeightMd': '650px',
	'dialogHeightMd_px': 650,

	// Roles/locations/members
	'rolesDialogWidth': '500px',
	'rolesDialogWidth_px': 500,
	'locationsDialogWidth': '500px',
	'locationsDialogWidth_px': 500,
	'membersDialogWidth': '500px',
	'membersDialogWidth_px': 500,
	'schedulingDialogWidth': '760px',
	'schedulingDialogWidth_px': 760,
	'schedulingDialogHeight': '650px',
	'schedulingDialogHeight_px': 650,

	// Add Project dialog
	'addProjectDialogWidth': '760px',
	'addProjectDialogWidth_px': 760,

	// Custom fields
	'customFieldDialogWidth': '1000px',
	'customFieldDialogWidth_px': 1000,
	'customFieldDialogHeight': '650px',
	'customFieldDialogHeight_px': 650,

	// Project info
	'projectInfoDialogWidth': '1000px',
	'projectInfoDialogWidth_px': 1000,

	// API settings dialog
	'apiSettingsDialogWidth': '1000px',
	'apiSettingsDialogWidth_px': 1000,

	// Box Shadows

	// plan constants
	'headerHeight': '62px',
	'headerHeight_px': 62,
	'sideMenuWidth': '84px',
	'sideMenuWidth_px': 84,
	'draftsAreaHeight': '132px',
	'draftsAreaHeight_px': 132,

	'ticketEditSheetWidth': '375px',
	'ticketEditSheetWidth_px': 375,
	'ticketEditSheetTitleHeight': '64px',
	'ticketEditSheetTitleHeight_px': 64,
	'ticketEditSpaceForDraftsButtons': '142px',
	'ticketEditSpaceForDraftsButtons_px': 142,

	// END of Material (Modern) Variables
	// **********************************************************************************************

	// Everything below here is in Plan Area only or not used at all... we can clean up the amount of variables we're using (omg less greys!) Remove eventually

	// Generic spacing pairings
	'spacingComboLg': 'var(--space-20) var(--space-16)',
	'spacingComboTbLg': 'var(--space-16) 0',

	// Disabled items opactiy
	'disabledOpacity': 0.38,

	// Box Shadows

	// Generic Box Sizes (to give a width or height to a component)
	'boxSize16': '16px',
	'boxSize16_px': 16,
	'boxSize24': '24px',
	'boxSize24_px': 24,
	'boxSize30': '30px',
	'boxSize30_px': 30,
	'boxSize40': '40px',
	'boxSize40_px': 40,
	'boxSize70': '70px',
	'boxSize70_px': 70,
	'boxSize90': '90px',
	'boxSize90_px': 90,
	'boxSize150': '150px',
	'boxSize150_px': 150,
	'boxSize200': '200px',
	'boxSize200_px': 200,
	'boxSize300': '300px',
	'boxSize300_px': 300,
	'boxSize350': '350px',
	'boxSize350_px': 350,
	'boxSize450': '450px',
	'boxSize450_px': 450,

	// Borders
	'primaryBorderRadius': '3px',
	'primaryBorderRadius_px': 3,
	'primaryBorder': '1px solid',
	'fatBorder': '10px solid',
	'borderDefault': 'var(--primary-border) var(--light-grey)',
	'borderTouchplanBlueDark': 'var(--primary-border) var(--touchplan-blue-dark)',
	'borderTouchplanBlue': 'var(--primary-border) var(--touchplan-blue)',
	'borderRedDarker': 'var(--primary-border) var(--touchplan-red-darker)',
	'borderRed': 'var(--primary-border) var(--red)',

	// Pointers
	'clickablePointer': 'pointer',
	'defaultPointer': 'default',

	// Outline
	'panelOutline': '1px solid var(--grey12)',

	// no data slash
	'noDataSlash': 'linear-gradient(45deg, #ddd, #ddd 49%, #f21202 51%, #f21202 52%, #ddd 53%, #ddd)',

	// Lists Item Heights
	'planListHeight': '72px',
	'planListHeight_px': 72,
	'projectListHeight': '240px',
	'projectListHeight_px': 240,
	'ticketListHeight': '100px',
	'ticketListHeight_px': 100,
};

// In rare cases, a variable needs to be looked up at runtime.
// For instance, if a CSS value references another CSS variable, having the string contain
// the variable reference instead of the variable value probably isn't helpful.
//
// The following can be used for runtime lookup.  For example, to do a runtime lookup of the
// value that corresponds to 'borderTouchplanBlueDark' ('--border-touchplan-blue-dark'),
// you can use this kind of code:
//
//     const style = getComputedStyle(document.documentElement);
//     const value = style.getPropertyValue(cssVarNames.borderTouchplanBlueDark);
//     console.log(cssVarNames.borderTouchplanBlueDark + ' = ' + value);
//
export const cssVarNames = {
	// NOTE:  A TypeScripe file, "css-var.ts", is auto-generated based on the contents of this file using
	// a custom code-generator we built.  If you modify this "_global.scss" file, please ask a
	// Desktop develop (e.g. Rich W.) to re-run that code-generator to update the corresponding
	// TypeScript.
	// The command line to update the content of "css-var.ts" file is:
	// npm run cssGen

	// Global Variables
	// Colors - Note our primary, accent and warn colors are located in touchplan-theme.scss these are our main colors and material adds them in for us.
	// Repeating a couple of examples here to match betwen Material and Legacy portions of the app
	// primary = touchplan dark blue, accent = orange, warn = red
	// Usage examples are not all-inclusive

	// Material (Modern) Color Palette
	'touchplanBlueDark': '--touchplan-blue-dark',
	'touchplanBlueDarker': '--touchplan-blue-darker',
	'touchplanBlue900': '--touchplan-blue-900',
	'touchplanBlue': '--touchplan-blue',
	'touchplanBlueLight': '--touchplan-blue-light',
	'touchplanBlueLighter': '--touchplan-blue-lighter',
	'touchplanBlueGrey': '--touchplan-blue-grey',
	'touchplanAccent': '--touchplan-accent',
	'white': '--white',
	'black': '--black',
	'purple': '--purple',
	// grey #'s are % opacity of black
	'grey2': '--grey2',
	'grey12': '--grey12',
	'grey38': '--grey38',
	'grey54': '--grey54',
	'grey60': '--grey60',
	'red': '--red',
	'yellow': '--yellow',
	'green': '--green',
	'lightGreen': '--light-green',
	'paleGreen': '--pale-green',
	'ghostlineBlue': '--ghostline-blue',
	'timelineTicketGrey': '--timeline-ticket-grey',
	'timelineHeight': '--timeline-height',
	'promisePeriodLastColor': '--promise-period-last-color',
	'promisePeriodLastAlpha': '--promise-period-last-alpha',
	'promisePeriodNextColor': '--promise-period-next-color',
	'promisePeriodNextAlpha': '--promise-period-next-alpha',
	'promisePeriodMinimizedAlpha': '--promise-period-minimized-alpha',
	'promisePeriodMinimizedHeight': '--promise-period-minimized-height',
	'promisePeriodTextSize': '--promise-period-text-size',
	'promisePeriodButtonWidth': '--promise-period-button-width',

	// *** do not use on new work *** Legacy Color Palette
	'lighterWhite': '--lighter-white',
	'lightGrey': '--light-grey',
	'grey': '--grey',
	'darkGrey': '--dark-grey',
	'darkerGrey': '--darker-grey',
	'almostBlack': '--almost-black',
	'touchplanRed': '--touchplan-red',
	'touchplanRedDarker': '--touchplan-red-darker',
	'touchplanRedDark': '--touchplan-red-dark',
	'touchplanRedLight': '--touchplan-red-light',
	'yellowLight': '--yellow-light',
	'yellowDark': '--yellow-dark',
	'greenDark': '--green-dark',
	'touchplanLime': '--touchplan-lime',
	'planAheadLegacy': '--plan-ahead-legacy',
	'planBehindLegacy': '--plan-behind-legacy',

	// Material (Modern) Size and Appearance Variables
	// Typography
	'fontFamily': '--font-family',
	// h1 - Material provides this
	'h2FontSize': '--h2-font-size',
	'h3FontSize': '--h3-font-size',
	'h4FontSize': '--h4-font-size',
	'h5FontSize': '--h5-font-size',
	'h6FontSize': '--h6-font-size',
	'listIconFontSize': '--list-icon-font-size',
	'largeCheckboxSize': '--large-checkbox-size',
	'fontawesomePro': '--fontawesome-pro',

	// Font Weights
	'thin': '--thin',
	'normal': '--normal',
	'medium': '--medium',
	'bold': '--bold',

	// Generic spacing: use this for paddings, margins, whatever that needs space added to it
	// Material increases padding by an increment of 4px
	'space4': '--space-4',
	'space8': '--space-8',
	'space12': '--space-12',
	'space16': '--space-16',
	'space20': '--space-20',
	'space24': '--space-24',
	'space40': '--space-40',

	// Dialog Box Sizes
	// widths
	'dialogWidthSm': '--dialog-width-sm',
	'dialogWidthMd': '--dialog-width-md',
	'dialogWidthLg': '--dialog-width-lg',
	'dialogWidthXl': '--dialog-width-xl',

	// heights - DEFAULT SHOULD BE TO NOT SPECIFY
	'dialogHeightSm': '--dialog-height-sm',
	'dialogHeightMd': '--dialog-height-md',

	// Roles/locations/members
	'rolesDialogWidth': '--roles-dialog-width',
	'locationsDialogWidth': '--locations-dialog-width',
	'membersDialogWidth': '--members-dialog-width',
	'schedulingDialogWidth': '--scheduling-dialog-width',
	'schedulingDialogHeight': '--scheduling-dialog-height',

	// Add Project dialog
	'addProjectDialogWidth': '--add-project-dialog-width',

	// Custom fields
	'customFieldDialogWidth': '--custom-field-dialog-width',
	'customFieldDialogHeight': '--custom-field-dialog-height',

	// Project info
	'projectInfoDialogWidth': '--project-info-dialog-width',

	// API settings dialog
	'apiSettingsDialogWidth': '--api-settings-dialog-width',

	// Box Shadows

	// plan constants
	'headerHeight': '--header-height',
	'sideMenuWidth': '--side-menu-width',
	'draftsAreaHeight': '--drafts-area-height',

	'ticketEditSheetWidth': '--ticket-edit-sheet-width',
	'ticketEditSheetTitleHeight': '--ticket-edit-sheet-title-height',
	'ticketEditSpaceForDraftsButtons': '--ticket-edit-space-for-drafts-buttons',

	// END of Material (Modern) Variables
	// **********************************************************************************************

	// Everything below here is in Plan Area only or not used at all... we can clean up the amount of variables we're using (omg less greys!) Remove eventually

	// Generic spacing pairings
	'spacingComboLg': '--spacing-combo-lg',
	'spacingComboTbLg': '--spacing-combo-tb-lg',

	// Disabled items opactiy
	'disabledOpacity': '--disabled-opacity',

	// Box Shadows

	// Generic Box Sizes (to give a width or height to a component)
	'boxSize16': '--box-size-16',
	'boxSize24': '--box-size-24',
	'boxSize30': '--box-size-30',
	'boxSize40': '--box-size-40',
	'boxSize70': '--box-size-70',
	'boxSize90': '--box-size-90',
	'boxSize150': '--box-size-150',
	'boxSize200': '--box-size-200',
	'boxSize300': '--box-size-300',
	'boxSize350': '--box-size-350',
	'boxSize450': '--box-size-450',

	// Borders
	'primaryBorderRadius': '--primary-border-radius',
	'primaryBorder': '--primary-border',
	'fatBorder': '--fat-border',
	'borderDefault': '--border-default',
	'borderTouchplanBlueDark': '--border-touchplan-blue-dark',
	'borderTouchplanBlue': '--border-touchplan-blue',
	'borderRedDarker': '--border-red-darker',
	'borderRed': '--border-red',

	// Pointers
	'clickablePointer': '--clickable-pointer',
	'defaultPointer': '--default-pointer',

	// Outline
	'panelOutline': '--panel-outline',

	// no data slash
	'noDataSlash': '--no-data-slash',

	// Lists Item Heights
	'planListHeight': '--planListHeight',
	'projectListHeight': '--projectListHeight',
	'ticketListHeight': '--ticketListHeight',
};
